import type { FunctionComponent, PropsWithChildren, ReactNode } from 'react';
import { Heading } from '../../../components/heading';
import type { CustomFieldsetId } from '../../../graphql/hooks/form-page';
import styles from './legend.module.scss';

/** Fieldset title, <legend>-like */
export const Legend: FunctionComponent<Props> = ({
  children,
  customFieldsetId,
  preset = 'default'
}) => <div className={styles.legend} data-sentry-component="Legend" data-sentry-source-file="index.tsx">
        <Heading id={legendId(customFieldsetId)} level={preset === 'primary' ? 1 : 2} className={styles.heading} data-sentry-element="Heading" data-sentry-source-file="index.tsx">
            {children}
        </Heading>
    </div>;
export const SubLegend: FunctionComponent<PropsWithChildren<any>> = ({
  children
}) => <div className={styles.sublegend} data-sentry-component="SubLegend" data-sentry-source-file="index.tsx">{children}</div>;
export const legendId = (customFieldsetId: CustomFieldsetId) => `${customFieldsetId}.legend`;
interface Props {
  /** Custom id of the parent fieldset. */
  customFieldsetId: CustomFieldsetId;
  /** Determines if this the main section on page, affects markup semantics. */
  preset?: 'primary' | 'default';
  children?: ReactNode;
}